import { usePartnerInfo } from "@/api/services/main/partner";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { PartnerDetailContent } from "@/features/partner/components/partner-detail/PartnerDetailContent";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

export const PartnerDetailPage = () => {
  const queryResult = usePartnerInfo();
  const { data, isLoading } = queryResult;
  useValidateId("partnerId", AppRoutes.partnerList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  return <PartnerDetailContent partner={data.data} />;
};
